<template>
  <div class="comment__idea-converted-card">
    <div class="comment__idea-converted-card__summary">
      <router-link
        :to="{
          name: 'epic',
          params: { projectId: route.params.projectId, epicId: epicSequenceNumber }
        }"
        class="comment__idea-converted-card__number"
      >
        <BaseSubHeading
          size="medium"
          weight="500"
        >
          E-{{ epicSequenceNumber }}
        </BaseSubHeading>
      </router-link>
      <BaseSubHeading
        size="medium"
        weight="400"
        color="monochrome-07"
        class="comment__idea-converted-card__title"
      >
        {{ epicTitle }}
      </BaseSubHeading>
    </div>
    <div class="comment__idea-converted-card__badges">
      <TShortComponent
        :size="ideaSize ?? 'none'"
        :label="ideaSize || '--'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router"
import { computed } from "vue"

import TShortComponent from "@/components/TShort/index.vue"

import { Comment } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const route = useRoute()

const epicSequenceNumber = computed(() => props.comment.ideaAuditRecord?.after?.epicSequenceNumber)
const epicTitle = computed(() => props.comment.ideaAuditRecord?.after?.epicTitle ?? "")
const ideaSize = computed(() => props.comment.ideaAuditRecord?.after?.size ?? null)
</script>
